import React, { Component, createElement } from "react";
import { Col, Row } from "react-bootstrap";
import { bool, func, shape, string } from "prop-types";
import { connect } from "react-redux";
import { CORPORATE_GROUP_ENVIRONMENT_TYPE } from "constants.js";
import moment from "moment";
import { push } from "connected-react-router";
import { compose } from "redux";
import { DateRangeField } from "pages/_components/fields/DateRangeField";
import { actions as transactionsActions, selectors as transactionsSelectors } from "reducers/transactions";

import * as Yup from "yup";
import { Field, Form, withFormik } from "formik";
import Selector from "pages/_components/fields/formik/Selector";
import Button from "pages/_components/Button";
import { selectors as sessionSelectors } from "reducers/session";

import * as i18n from "util/i18n";

const FORM_ID = "transactions.list.filters.period";


class HiddenFilters extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        handleClickHideFilters: func.isRequired,
        fetching: bool,
        searchByStatus: bool,
        onlyPendings: bool,
        pendingDispatch: bool,
        activeEnvironment: shape({ type: string.isRequired }).isRequired,
        setFieldValue: func.isRequired,
    };

    static defaultProps = {
        fetching: false,
        onlyPendings: false,
        pendingDispatch: false,
        searchByStatus: false,
    };

    handleClear = () => {
        const { setFieldValue } = this.props;
        setFieldValue("dateRange", [null, null]);
    };

    state = {
        selectedFilter: "period",
    };

    handleChange = (selectedOption) => {
        this.setState({ selectedFilter: selectedOption.value });
    };

    render() {
        const { activeEnvironment, searchByStatus } = this.props;

        let options = [
            {
                value: "period",
                label: i18n.get("accounts.movements.filters.searchBy.period"),
            },
            {
                value: "amount",
                label: i18n.get("accounts.movements.filters.searchBy.amount"),
            },
        ];
        if (searchByStatus) {
            options = [
                ...options,
                {
                    value: "status",
                    label: i18n.get("accounts.movements.filters.searchBy.status"),
                },
            ];
        }
        if (activeEnvironment.type === CORPORATE_GROUP_ENVIRONMENT_TYPE) {
            options = options.concat({
                value: "environment",
                label: i18n.get("accounts.movements.filters.searchBy.client"),
            });
        }

        return (
            <Form className="transaction-filter">
                <Row className="filters">
                    <Col className="col-12" sm={12} md={6}>
                        <Field
                            name="searchBy"
                            clearable={false}
                            searchable={false}
                            onChange={this.handleChange}
                            label={`${i18n.get("accounts.movements.filters.searchBy")}`}
                            placeholder={i18n.get("global.select.option.placeholder")}
                            component={Selector}
                            options={options}
                        />
                    </Col>
                    <Col className="col-12" sm={12} md={6}>
                        <Field
                            component={DateRangeField}
                            hidePlaceholder
                            idForm={FORM_ID}
                            minDate={moment().add(-10, "years")}
                            maxDate={moment()}
                            name="dateRange"
                            dateFormat="dd/MM/yyyy"
                            selectsRange
                            showMonthYearDropdown
                            scrollableMonthYearDropdown
                            noEdit
                        />
                    </Col>
                </Row>
                <Row className="filter-footer">
                    <Col sm={12} md={6} className="col-12 col-no-pad-mobile" style={{ alignSelf: "flex-end" }}>
                        <Button bsStyle="outline" label="transactions.clean.filters" onClick={this.handleClear} />
                    </Col>
                    <Col sm={12} md={6} className="col-12 col-no-pad-mobile" style={{ alignSelf: "flex-end" }}>
                        <Button bsStyle="primary" label="product.filters.filter" type="submit" block />
                    </Col>
                </Row>
            </Form>
        );
    }
}

const mapStateToProps = (state) => ({
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    filters: transactionsSelectors.getFilters(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        validateOnChange: true,
        validateOnBlur: false,
        mapPropsToValues: (state) => ({
            dateFrom: state?.filters?.dateFrom || null,
            dateTo: state?.filters?.dateTo || null,
            dateRange: [state?.filters?.dateFrom || null, state?.filters?.dateTo || null],
        }),
        validationSchema: () =>
            Yup.lazy((values) =>
                Yup.object().shape({
                    dateFrom: values.dateTo
                        ? Yup.date()
                              .nullable()
                              .max(values.dateTo, i18n.get("accounts.movements.filters.from.error"))
                        : Yup.date().nullable(),
                    dateTo: values.dateFrom
                        ? Yup.date()
                              .nullable()
                              .min(values.dateFrom, i18n.get("accounts.movements.filters.to.error"))
                        : Yup.date().nullable(),
                }),
            ),
        handleSubmit: ({ ...filters }, formikBag) => {
            const { dispatch, isDesktop, onlyPendings, pendingDispatch, handleClickHideFilters } = formikBag.props;
            let dateFrom = filters?.dateRange[0];
            let dateTo = filters?.dateRange[1];
            if (filters.dateRange[0] === null) {
                dateFrom = moment().add(-1, "years");
            }
            if (filters.dateRange[1] === null) {
                dateTo = moment();
            }
            if (filters.dateRange[1] === null && filters.dateRange[0] === null) {
                dateFrom = moment().add(-1, "years");
                dateTo = moment();
            }
            if (isDesktop) {
                dispatch(
                    transactionsActions.loadListRequest(
                        { dateFrom, dateTo, pageNumber: 1 },
                        onlyPendings,
                        pendingDispatch,
                        false,
                        formikBag,
                    ),
                );
            } else {
                dispatch(
                    transactionsActions.setFilters({
                        filter: "period",
                        ...filters,
                    }),
                );
                dispatch(push(`/transactions/list/filters/results`));
            }
            handleClickHideFilters();
        },
    }),
)(HiddenFilters);
